module.exports = __webpack_public_path__ + "img/scan (16).b4e9ce34.png";